module.exports = __webpack_public_path__ + "img/5.a97fe77d.png";